import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { hasActionAccess } from "utility";
import { useGetBlogsQuery, useDeleteBlogMutation } from "slices/cms/blogSlice";

function Media() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteBlogMutation();
  const auth = useSelector((state) => state.auth.auth?.user);

  const { data, isLoading, refetch } = useGetBlogsQuery({
    page,
    limit,
    search,
    type: "media-coverage",
  });

  const col = [
    { display: "Title", key: "title", type: "display" },
    {
      display: "Description",
      key: "description",
      type: "display",
      render: (row) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = row.description;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";
        const truncated =
          textContent.length > 100
            ? textContent.slice(0, 100) + "..."
            : textContent;
        return <span title={textContent}>{truncated}</span>;
      },
    },
    {
      display: "Image",
      key: "authorImage",
      type: "image",
      style: { width: "100px", height: "100px", borderRadius: "20%" },
    },
  ];
  const canEdit = hasActionAccess(auth, "CMS", "Media Coverage", "edit");
  const canDelete = hasActionAccess(auth, "CMS", "Media Coverage", "delete");
  if (canEdit || canDelete) {
    col.push({
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          {canEdit && <Button onClick={() => onEdit(row)}>Edit</Button>}
          {canDelete && (
            <Button onClick={() => handleDelete(row._id)}>Delete</Button>
          )}
        </>
      ),
    });
  }

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };

  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const onEdit = (row) => {
    navigate(`/cms/media-coverage/update/${row._id}`, {
      state: { refresh: true },
    });
  };

  const handleAdd = () => {
    navigate("/cms/media-coverage/add");
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this media?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  const canAdd = hasActionAccess(auth, "CMS", "Media Coverage", "add");

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {canAdd && (
        <Button onClick={handleAdd} style={{ background: "#fff" }}>
          Add+
        </Button>
      )}

      <Tables
        title={"Media"}
        handleSearch={handleSearchChange}
        totalPages={data?.total}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Media;
